import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../redux/actions';
import * as commonActions from '../../common/redux/actions';
import * as pluginActions from '../../plugin/redux/actions';
import { EditorState, ContentState } from 'draft-js';
import htmlToDraft from 'html-to-draftjs';
import { getTemplateFormCollectionFieldOptions } from './TypesenseSeachTemplateFormUtils';
import { drapcodeIcon } from '../../../common/custom/icon-library';
import ParentDocCard from '../../common/ParentDocCard';
import { TemplateHeaderNav } from '../TemplateHeaderNav';
import { TYPESENSE_SEARCH_TEMPLATE } from 'drapcode-constant';
import TypesenseSearchTemplateForm from './TypesenseSearchTemplateForm';
import { isProjectReadOnly } from '../../../common/utils/api_utils';

export class TypesenseSearchTemplateEdit extends Component {
  static propTypes = {
    template: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    editorState: EditorState.createEmpty(),
    name: '',
    collectionId: '',
    selectedCollectionFields: [],
  };

  componentDidMount = () => {
    const { match, actions, pluginActions } = this.props;
    const { projectId, templateId, version } = match.params;
    const args = { projectId, templateId, version };
    actions.loadProjectDetail({ projectId, version });
    actions.loadCollections({ projectId, version });
    actions.fetchTemplate(args);
    pluginActions.loadAllInstalledPlugin({ projectId, version });
  };

  shouldComponentUpdate = (nextProps, nextState) => {
    const {
      template: { template, collections },
    } = nextProps;
    const { name: stateName } = this.state;
    if (!stateName) {
      const { content, name, collectionId } = template ? template : {};
      const selectedCollection = collections.find((e) => e.collectionName === collectionId);
      const selectedCollectionFields = selectedCollection
        ? getTemplateFormCollectionFieldOptions(selectedCollection, collections)
        : [];
      if (content) {
        const blocksFromHtml = htmlToDraft(content);
        const { contentBlocks, entityMap } = blocksFromHtml;
        const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
        const editorState = EditorState.createWithContent(contentState);
        this.setState({
          name: name,
          collectionId: collectionId,
          editorState: editorState,
          selectedCollectionFields: selectedCollectionFields,
        });
      }
    }

    return true;
  };

  handleSubmit = (values) => {
    const { projectId, templateId, version } = this.props.match.params;
    let args = {
      projectId: projectId,
      templateId: templateId,
      version,
      values: values,
    };
    this.props.actions.updateTemplate(args);
  };
  toggle = (activeTab) => {
    const { projectId, version } = this.props.match.params;
    this.props.history.push({
      pathname: `/template/${version}/v/${projectId}`,
      state: { activeTab: activeTab },
    });
  };
  render() {
    const { editorState, name, collectionId, selectedCollectionFields } = this.state;
    const {
      template: { collections, updateTemplatePending, template },
      projectDetail,
      match,
      plugin: { installedPlugins },
    } = this.props;
    const { projectId, templateId } = match.params;
    const isReadOnly = isProjectReadOnly(projectId);
    return (
      <div className="main">
        <div className="section">
          <div className="container">
            <TemplateHeaderNav
              activeTab={TYPESENSE_SEARCH_TEMPLATE}
              title={'Typesense Search Templates'}
              toggle={this.toggle}
              installedPlugins={installedPlugins}
            />
            <div className="row mx-auto">
              <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
                <div className="card">
                  <div
                    className="card-header card-header-icon"
                    data-background-color="drapcode-dark-blue"
                  >
                    <i className={`wb ${drapcodeIcon(TYPESENSE_SEARCH_TEMPLATE)}`}></i>
                  </div>
                  <div className="card-content">
                    {name ? (
                      <TypesenseSearchTemplateForm
                        handleSubmit={this.handleSubmit}
                        editorState={editorState}
                        name={name}
                        collectionId={collectionId}
                        collections={collections}
                        selectedCollectionFields={selectedCollectionFields}
                        updateTemplatePending={updateTemplatePending}
                        templateId={templateId}
                        projectDetail={projectDetail}
                        isReadOnly={isReadOnly}
                      />
                    ) : null}
                  </div>
                </div>
              </div>
              <ParentDocCard>
                <h5>
                  <b>Typesense Search Template</b>
                </h5>
                <p>
                  You can create custom Typesense Search Template and use them to display typesense
                  search results your way.
                </p>
                <br />
              </ParentDocCard>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    template: state.template,
    projectDetail: state.home.projectDetail,
    plugin: state.plugin,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions, ...commonActions }, dispatch),
    pluginActions: bindActionCreators({ ...pluginActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(TypesenseSearchTemplateEdit);
